import { render, staticRenderFns } from "./attach-delivery.vue?vue&type=template&id=7610e63d&"
import script from "./attach-delivery.vue?vue&type=script&lang=js&"
export * from "./attach-delivery.vue?vue&type=script&lang=js&"
import style0 from "./attach-delivery.vue?vue&type=style&index=0&id=7610e63d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports